// components
import {
  styled,
  Grid,
  GridProps,
  Typography,
  TypographyProps,
  Stack,
  StackProps
} from '@mui/material';
import { IconContainer } from 'components/shared/Header/Header.styles';
import { ScrollbarBox } from '@sdb/planning-ui';

export const StyledLeftGridContainer = styled(Grid)<GridProps>(() => ({
  alignContent: 'flex-start',
  width: '100%'
}));

export const StyledIntroDashboardGrid = styled(Grid)<GridProps>(
  ({ theme }) => ({
    backgroundColor: theme.palette.primary.main,
    borderRadius: theme.shape.borderRadius,
    boxShadow: theme.shadows[1],
    color: theme.palette.common.white,
    padding: theme.spacing(6),
    height: '220px',
    position: 'relative',
    overflow: 'hidden'
  })
);

export const StyledBoldWhiteTypography = styled(Typography)<TypographyProps>(
  ({ theme }) => ({
    color: theme.palette.common.white,
    fontFamily: 'SourceSansPro-Bold'
  })
);

export const StyledIntroDashboardStack = styled(Stack)<StackProps>(
  ({ theme }) => ({
    flexDirection: 'row',
    gap: theme.spacing(4),
    backgroundColor: theme.palette.primary.main,
    borderRadius: theme.shape.borderRadius,
    position: 'relative',
    zIndex: 10,
    width: 'max-content',
    padding: theme.spacing(4, 4, 4, 0),
    marginBottom: theme.spacing(-4),

    '& .ticker-rotation-buttons': {
      opacity: 0,
      transition: 'opacity .2s ease-in-out'
    },

    '&:hover .ticker-rotation-buttons': {
      opacity: 1
    }
  })
);

export const StyledIntroDashboardStackCustomWidth = styled(
  StyledIntroDashboardStack
)<StackProps>(() => ({
  width: '50%'
}));

export const Styled32SizeIconContainer = styled(IconContainer)(() => ({
  width: '32px',
  height: '32px'
}));

export const StyledDashboardWaveImage = styled('img')(() => ({
  backgroundPosition: 'bottom',
  position: 'absolute',
  right: -20,
  bottom: -30,
  width: '300px',
  height: '300px'
}));

export const StyledDashboardCalendarImage = styled('img')(() => ({
  backgroundPosition: 'bottom',
  position: 'absolute',
  right: 20,
  bottom: -68,
  width: '240px',
  height: '240px'
}));

export const StyledCustomScrollbarBoxNoBg = styled(ScrollbarBox)(() => ({
  '&&::-webkit-scrollbar-track, && *::-webkit-scrollbar-track': {
    backgroundColor: 'transparent',
    margin: '10px 0'
  }
}));
